import React from "react";
import { Link } from "react-router-dom";
import B2bAds from "../../assets/sidebarImgs/B2bAds.png";
// import EGC from "../../assets/sponsors/EGC india.png";
import Excellency from "../../assets/sponsors/ELSPL.png";
import { Carousel } from "react-bootstrap";


const AddBanner = [
  {
    url: "/aecci-virtual-b2b-forum",
    image: B2bAds,
  },
  // {
  //   url: "#",
  //   image: Excellency,
  // },
  // {
  //   url: "#",
  //   image: EGC,
  // },
];

function AddBannerCarousel() {
  return (
    <Carousel controls={false} indicators={false} interval={5000}>
      {AddBanner.map((ad, index) => (
        <Carousel.Item key={index}>
          <Link to={ad.url} rel="noopener noreferrer">
            <img src={ad.image} alt={`Ad ${index + 1}`} width="100%" height="auto" />
          </Link>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default AddBannerCarousel;
